import API from "../../api";
import user from "@/store/modules/user";

export default {
  namespaced: true,

  state: {
    closedCities: [
      "Novo Hamburgo",
      "Florianópolis",
      "São José",
      "Pinhais",
      "São José dos Pinhais"
    ]
  },

  actions: {
    async create({ commit }, payload) {
      try {
        return await API.Addresses.create(payload);
      } catch (e) {
        throw e;
      }
    },

    async update({ commit }, payload) {
      try {
        return await API.Addresses.update(payload);
      } catch (e) {
        throw e;
      }
    },

    async getByUser({ commit }) {
      try {
        let type = user.state.user.accountable.type;
        type = type.charAt(0).toUpperCase() + type.slice(1);
        return await API[type].getAddresses(user.state.user.accountable.id);
      } catch (e) {
        throw e;
      }
    },

    async destroy({ commit }, id) {
      try {
        return await API.Addresses.destroy(id);
      } catch (e) {
        throw e;
      }
    }
  },

  mutations: {},

  getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses.js